import { IconSVG } from '../types';

export const MaximizeWindow = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M6 14h7c.283 0 .52-.096.713-.287A.968.968 0 0014 13V8a.967.967 0 00-.287-.713A.968.968 0 0013 7H6a.968.968 0 00-.713.287A.968.968 0 005 8v5c0 .283.096.52.287.713.192.191.43.287.713.287zm-2 6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 012 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 014 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0120 20H4zm0-2h16V6H4v12z"
      />
    </svg>
  );
};
